import useState from 'react-usestateref';
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import {
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  IconButton,
  Box,
  Grid,
  Divider,
  Dialog,
  ButtonGroup
} from "@mui/material";
import { Visibility, VisibilityOff, Close } from "@mui/icons-material";
import {
  storeUserSession,fetchNewToken,callApi,callApiNoHeader,copyDir
} from '../authorization/FetchToken';
import { useAuth } from '../pages/AuthContext';
import Spinner from '../Spinner';
import Snackbar from '@mui/material/Snackbar'; 
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect} from "react";


const Login = () => {
  const [showPage, setShowPage] = useState("signIn"); // "signIn" | "register" | "forgotPwd" | "payment"
  const [orgName, setOrgName] = useState("");
  const [orgId, setOrgId,orgIdRef] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [success, setSuccess] = useState("");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [userType, setUserType] = useState("organisation");
  const INVERTIBLE_MANAGED_ORG = "invertible_managed";
  const INVERTIBLE_MANAGED_USER_ROLE = "INDIVIDUAL_USER";
  const INVERTIBLE_MANAGED_ORG_ID = "8840618d-9fe8-11d1-9f70-0352se120101";
  const [loadExamples, setLoadExamples] = useState(false);

  const [billingAddress, setBillingAddress] = useState({
    billingContactName:"",
    line1: "",
    line2: "",
    city: "",
    postalCode: "",
    country: "",
  });
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // 🔹 Sign In flow
const { initSession,expiry } = useAuth();

useEffect(() => {
  console.log("userSessionRefLogin:1")
  if (userType === "individual") {
    setOrgName(INVERTIBLE_MANAGED_ORG);
  } else {
    setOrgName(""); // or previous value
  }
}, [userType]);
console.log("userSessionRefLogin:2",userType)

const copyExamples = async (e) => {
  console.log("inCopyExamples:2",userType)
  if(userType !== "individual"){
  //const cpFuntionsFile = await copyFile("/home/stateFiles/" + org_name + "/" + `${process.env.REACT_APP_ARCHITECTURE_NAME}` + "/functions/functions" , `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DATA_DIR}functions/functions`,userSessionRef.current["orgName"])
  const cpAiAgent = await copyDir("/home/invertibleFiles/boolean/documents/examples/aiagent", "/home/stateFiles/" + orgName + "/" + `${process.env.REACT_APP_ARCHITECTURE_NAME}` + "/" ,orgName)
  const cpConfig = await copyDir("/home/invertibleFiles/boolean/documents/examples/config", "/home/stateFiles/" + orgName + "/" + `${process.env.REACT_APP_ARCHITECTURE_NAME}` + "/" ,orgName)
  const cpUploads = await copyDir("/home/invertibleFiles/boolean/documents/examples/uploads", "/home/stateFiles/" + orgName + "/" + `${process.env.REACT_APP_ARCHITECTURE_NAME}` + "/" ,orgName)
  
  } else if (userType === "individual") {
    console.log("copyingUploads:2",userType)
    const cpUploads = await copyDir("/home/invertibleFiles/boolean/documents/examples/individual_uploads/uploads", "/home/stateFiles/" + orgName + "/" + `${process.env.REACT_APP_ARCHITECTURE_NAME}` + "/uploads/" + `${email}` + "/" ,orgName)
                                                                                                              ///home/stateFiles/invertible_managed/default/uploads/vasistabhargava@gmail.com/uploads
  }

}

const handleSignIn = async (e) => {
    e.preventDefault();
    setError("");
    setShowResend(false);
    setLoading(true);
    console.log("signin_details::1", orgName, email, password);

    try {

      // 2️⃣ verify user
      if ((!email) || (!password)) {
        setError("Email and Password required for Login");
        return;
      }

      let resp = {};
      let paymentStatus = "";
    
    if (orgName == INVERTIBLE_MANAGED_ORG) {
          const userEmail = orgName + "`" + email;
          resp = await callApiNoHeader("/userDetails", {
            email: userEmail,
          });
          if (resp?.message === "NO_USER_FOUND") {
            setError("User does not exist.");
            return;
          }
            setOrgId(resp.userRelData.ORG_ID)
            paymentStatus = resp.userData.PAYMENT_STATUS
            
      } else {
      // 1️⃣ check org existence
        resp = await callApiNoHeader("/checkOrgExistanceWithName", { orgName });
      if (!resp.Exist) {
        setError("Organisation does not exist.Register for new root user or contact your administrator");
        return;
      }
        setOrgId(resp.OrgId)
        paymentStatus = resp.PaymentStatus
            
    }
      
    console.log("resp::1",orgIdRef.current)

    const data = await callApiNoHeader("/verifyUser", { orgName, email, password });
    console.log("data.status::1",data)

  const resendVerificationEmail = async () => {
      try {
          await callApiNoHeader("/sendEmailLinkAccountManagement", {
              email: orgName + "`" + email,
              emailType: "email"
          });
  
          //setSuccess("A new verification link has been sent to your email.");
      } catch (err) {
          console.error(err);
          setError("Could not send the verification email.Please try again.");
      }
  };
      
  if (data.status == "true") {
      //localStorage.setItem("user", JSON.stringify(email));
      //const expirationTime = new Date().getTime() + 60 * 60 * 1000; // 24 hours from now
      //localStorage.setItem('loginExpiration', expirationTime);
      const jwtResp = await fetchNewToken(orgName, email, password);
      const token = jwtResp.token;
      const token_expiry = Date.now() + jwtResp.expiresIn * 1000;
      console.log("token,expiresIn::1",token,jwtResp)
      if (!token || token!="") {
        localStorage.setItem("jwtToken", token);
        localStorage.setItem("jwtExpiry", token_expiry);
      }

    } else {
      if (data.status === "EMAIL_NOT_VERIFIED") {
        setError(
            <>
                Email not verified. Please check your email.{" "}
                <br></br>
                <button
                    type="button"
                    onClick={resendVerificationEmail}
                    className="link"
                >
                    Resend verification link
                </button>
            </>
        );
        return;
    } else {
        console.log("data.status::2",data)
        //setError(data.status);
        setError("Signin failed.Please Check User credentials or Please contact your administrator")
        return;
      }
    }
     

    if (paymentStatus == "CANCELLED") {
      setError("User doesn't exist")
      return;

      }

      // Do not Delete//
      //Remove condition on payment status 'TRIAL' on registration after trial period offerings are stopped.
      //if (orgResp.PaymentStatus !== "COMPLETE") {
        if (paymentStatus !== "COMPLETE" && paymentStatus !== "TRIAL") {
          if (orgName == INVERTIBLE_MANAGED_ORG) {
            setError("Please provide valid card details to Validate Account.");
              setShowPage("payment");
              return;
          } else {
            if (resp.RootEmail == orgName + "`" + email) {
              setError("Please provide valid card details to Validate Account.");
              setShowPage("payment");
              return;
          } else {
          setError("Organisation is not in a valid state. Contact support.");
          return;
          }
        } 
  
        }
    
    //if (localStorage.getItem('loginExpiration')) {
    const completeEmail =  orgName + "`" + email;
    const userProfile =  await callApi("/userProfile", {
    //const userProfile =  await callApiNoHeader("/userProfile", {
        email : completeEmail
        });
    console.log("userProfile::1", userProfile.userRelData.ROLE)
    //localStorage.setItem('userRole',userProfile.userRelData.ROLE)
    resp = await storeUserSession(orgName,orgIdRef.current,JSON.stringify(email),"",userProfile.userRelData.ROLE,paymentStatus)
    console.log("userSession::1",resp["token"])
    localStorage.setItem('token', resp["token"]);
    const sessionData = await initSession();

  if (!sessionData) {
    setError("User doesn't exist")
    //navigate("/");
    return;
  }

  const expiryTime = new Date(sessionData.expiresAt).getTime();
  const now = Date.now();

  console.log("expiry::1", expiryTime > now);

  if (expiryTime > now) {
    if (
      orgName === INVERTIBLE_MANAGED_ORG ||
      userProfile.userRelData.ROLE?.toLowerCase() === "functions_subscriber"
    ) {
      if (loadExamples) {
        await copyExamples();
      }
      navigate("/applyFunctions")
    } else { 
      if (loadExamples) {
        await copyExamples();
      }
      navigate("/listConnectionPage")
    };
  } else {
    localStorage.clear();
    navigate("/");
    //setShowPage("signIn");
  }
//}
} catch (err) {
  console.log("Login failed: " + err.message);
} finally {
  setLoading(false);
}
};


// 🔹 Register flow
const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    if (!acceptedTerms) {
      setError("Please accept Terms and Privacy Policy");
      return;
    }

    if (/\s/.test(orgName)) {
      setError("Spaces are not allowed in the organisation name");
      return;
    }

    if (orgName.includes("`")) {
      setError("Character ` (backtick) is not allowed in the organisation name");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    if (["invertible", "invertible.io"].includes(orgName.toLowerCase().trim())) {
      setError("Organisation already exists");
      return;
    }

    if (email.includes("`")) {
      setError("Character ` (backtick) is not allawed in email id's");
      return;
    }

    try {
    setLoading(true);
    if (orgName == INVERTIBLE_MANAGED_ORG) {
      const userEmail = orgName + "`" + email;
      const resp = await callApiNoHeader("/userDetails", {
        email: userEmail,
      });
      if (resp?.message !== "NO_USER_FOUND") {
        setError("User already exists.Please sign in");
        return;
      }
        //setOrgId(resp.UserId)
        const payload = {
          orgId:INVERTIBLE_MANAGED_ORG_ID,
          orgName:INVERTIBLE_MANAGED_ORG,
          createdBy:"invertible",
          name: name,
          email: email,
          password: password,
          role: INVERTIBLE_MANAGED_USER_ROLE,
        };
        const userResp = await callApiNoHeader("/createIndividualUser", payload);
        if (userResp?.message?.includes("USER_ACCOUNT_ALREADY_EXISTS")) {
          setError("User Account Already Exists.Please sign in")
          return;
    
        } else if (resp?.code ==500) {
          setError("Something went wrong. Please try again later.")
          return;
        }
    
  } else {
    const orgResp = await callApiNoHeader("/checkOrgExistanceWithName", { orgName });
      if (orgResp.Exist) {
        setError("Organisation already exists.");
        return;
      }
      
    await callApiNoHeader("/createOrganizationWithRootUser", {
      orgName,
      email,
      password,
      name,
    });
  }


      //*** Do not Delete ***
      //Enable to show payment screen on registration after trial period offerings are stopped.
      //setShowPage("payment");
      //Disable if no Trial Period
      await handleTrialPeriod()

    } catch (err) {
      setError("Registration failed: " + err.message);
    } finally {
    setLoading(false);
  }
    };
    /////////

  
  // 🔹 Forgot password
const handleForgotPwd = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {

    //const delay = ms => new Promise(res => setTimeout(res, ms));
    
    const resp = await callApiNoHeader("/sendEmailLinkAccountManagement", {
        email:orgName + "`" + email,
        emailType:"password"
    });
  

    setSuccess("Password reset email for this organisation has been sent to your email.If it doesn't arrive in the next 5 minutes click reset button again");
    //setShowPage("signIn");


    } catch (err) {
      //EMAIL_NOT_FOUND
      //const extractedMessage = extractErrorMessage(err);
      if (err.message.includes("INVALID_EMAIL")) {
        setError("Failed to send reset link: Email is invalid");
      } else if (err.message.includes("EMAIL_NOT_FOUND")) {
        setError("Failed to send reset link: Email doesnt exist");
        //setError("Failed to send reset link: " + err.message);

      } else {
        setError("Failed to send reset link: Check your email and organisation or contact invertible");
      }
      
    } finally {
        setLoading(false);
      }
      //{"code":500,"message":"http error status: 400; body: {\n \"error\": {\n \"code\": 400,\n \"message\": \"INVALID_EMAIL\",\n \"errors\": [\n {\n \"message\": \"INVALID_EMAIL\",\n \"domain\": \"global\",\n \"reason\": \"invalid\"\n }\n ]\n }\n}\n"}
  };
  

// 🔹 Trial period flow
const handleTrialPeriod = async () => {
  //e.preventDefault();
  setError("");
  try {
    // 2️⃣ Call backend routes
    /*
    const customer = await callApi("/create-customer", { email });
    console.log("ID::1", customer.customer.id)
    */
    let resp = {};
  if (orgName==INVERTIBLE_MANAGED_ORG) {
      resp = await callApiNoHeader("/sendEmailLinkAccountManagement", {
        email:orgName + "`" + email,
        emailType:"user_email"
      });

    } else {
    resp = await callApiNoHeader("/sendEmailLinkAccountManagement", {
      email:orgName + "`" + email,
      emailType:"email"
    });
  }
    //{"code":500,"message":"http error status: 400; body: {\n  \"error\": {\n    \"code\": 400,\n    \"message\": \"TOO_MANY_ATTEMPTS_TRY_LATER\",\n    \"errors\": [\n      {\n        \"message\": \"TOO_MANY_ATTEMPTS_TRY_LATER\",\n        \"domain\": \"global\",\n        \"reason\": \"invalid\"\n      }\n    ]\n  }\n}\n"}
    console.log("handleTrialPeriod ::1",resp)
    if (resp?.message?.includes("TOO_MANY_ATTEMPTS_TRY_LATER")) {
      setError("Too many attempts. Please try again later.")
      return;

    } else if (resp?.code ==500) {
      setError("Something went wrong. Please try again later.")
      return;
    }


    //navigate("/");
    setSuccess("User created.Verification email has been sent")
    setShowPage("signIn")
  } catch (err) {
    setError("Creation failed.Please try again later or contact support@invertible.io");
  }
};


const validateBillingAddress = () => {
  const { billingContactName,line1,city, postalCode, country } = billingAddress;

  if (!billingContactName || !line1 || !city || !postalCode || !country) {
    setError("Please fill in all required fields");
    return false;
  }

  return true;
};

// 🔹 Payment flow
const handlePayment = async (e) => {
    e.preventDefault();
    setError("");
    console.log("validateBillingAddress::1",validateBillingAddress())
    if (!validateBillingAddress()) {
      return;
    }

    console.log("Stripe:", stripe);
    console.log("Elements:", elements);
    
    if (!stripe || !elements) {
      setError("Stripe has not loaded yet. Please try again.");
      return;
    }

    setLoading(true);
    setError("");

    const cardElement = elements.getElement(CardElement);

    const { error: pmError, paymentMethod } =
    await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
      billing_details: {
        name: orgName,
        email: email,
      },
    });

    if (pmError) {
      setError(pmError.message);
      setLoading(false);
      return;
    }

    try {
      // 2️⃣ Call backend routes
      const customer = await callApiNoHeader("/create-customer", {
        name: orgName, 
        email: email,
        billing_contact_name: billingAddress.billingContactName,
        line1: billingAddress.line1,
        line2: billingAddress.line2,
        city: billingAddress.city,
        postal_code: billingAddress.postalCode,
        country: billingAddress.country,
        });
      console.log("ID::1", customer.customer.id)
      await callApiNoHeader("/attachPayment", {
        customerId: customer.customer.id,
        paymentMethodId: paymentMethod.id,
      }); 

      await callApiNoHeader("/verifyCardPayment", {
        customerId: customer.customer.id,
        paymentMethodId: paymentMethod.id,
        email: email,
        orgName: orgName
      });

      if (orgName == INVERTIBLE_MANAGED_ORG) {
        await callApiNoHeader("/invidualUserPaymentStatus", {
          email,
          orgName,
          orgId,
        });
    } else {

        await callApiNoHeader("/paymentStatus", {
          email,
          orgName,
          orgId,
        });
    }

      await callApiNoHeader("/sendEmailLinkAccountManagement", {
        email:orgName + "`" + email,
        emailType:"payment"
      });

      //navigate("/");
      setSuccess("Verification email has been sent")
      setShowPage("signIn")
    } catch (err) {
      setError("Payment failed: " + err.message);
    } finally {
      setLoading(false);
    }
  };



  const renderSignIn = () => (
    <>
      <Typography
        variant="h6"
        sx={{ fontWeight: 600, mb: 3, textAlign: "center" }}
      >
        Sign In
      </Typography>
  
      {/* USER TYPE SELECTION */}
      <Box sx={{ mb: -1 }}>
  
        <ButtonGroup fullWidth>
          <Button
            variant={userType === "organisation" ? "contained" : "outlined"}
            onClick={() => setUserType("organisation")}
          >
            Organisation
          </Button>
  
          <Button
            variant={userType === "individual" ? "contained" : "outlined"}
            onClick={() => {
              setUserType("individual");
              setOrgName(INVERTIBLE_MANAGED_ORG);
            }}
          >
            Individual
          </Button>
        </ButtonGroup>
      </Box>
  
      <form onSubmit={handleSignIn}>
        
        {/* ORGANISATION FIELD ONLY FOR ORG USERS */}
        {userType === "organisation" && (
          <TextField
            label="Organisation"
            fullWidth
            margin="normal"
            value={orgName}
            onChange={(e) => setOrgName(e.target.value)}
          />
        )}
  
        <TextField
          label="Email"
          type="email"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
  
        {/* PASSWORD */}
        <Box sx={{ position: "relative", mt: 2 }}>
          <TextField
            label="Password"
            type={showPassword ? "text" : "password"}
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
  
          <IconButton
            onClick={() => setShowPassword(!showPassword)}
            sx={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </Box>
  
        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{ mt: 3, py: 1.2, backgroundColor: "#2563eb" }}
        >
          Sign In
        </Button>
      </form>
  
  <div style={{ marginTop: "12px", paddingLeft: "4px" }}>
  <label
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      cursor: "pointer",
      fontSize: "14px",
    }}
  >
    <input
      type="checkbox"
      checked={loadExamples}
      onChange={(e) => setLoadExamples(e.target.checked)}
    />
    Load Examples
  </label>
</div>


      <Typography variant="body2" sx={{ mt: 3, textAlign: "center" }}>
        <span
          style={{ color: "#2563eb", cursor: "pointer" }}
          onClick={() => setShowPage("register")}
        >
          Register
        </span>{" "}
        |{" "}
        <span
          style={{ color: "#2563eb", cursor: "pointer" }}
          onClick={() => setShowPage("forgotPwd")}
        >
          Forgot Password?
        </span>
      </Typography>
  
      <br />

    <div style={{ marginTop: 18, fontSize: 12 }}>
        <span>
        By signing in, you agree to our Terms of Service and Privacy Policy.
            </span>
        </div>

    </>
  );

const renderRegister = () => (
    <>
      <Typography
        variant="h6"
        sx={{ fontWeight: 600, mb: 3, textAlign: "center" }}
      >
        Register
      </Typography>

      {/* USER TYPE SELECTION */}
    <Box sx={{ mb: 2 }}>

      <ButtonGroup fullWidth>
        <Button
          variant={userType === "organisation" ? "contained" : "outlined"}
          onClick={() => setUserType("organisation")}
        >
          Organisation
        </Button>

        <Button
          variant={userType === "individual" ? "contained" : "outlined"}
          onClick={() => setUserType("individual")}
        >
          Individual
        </Button>
      </ButtonGroup>
    </Box>
  
      <form onSubmit={
        handleRegister
        }>

      {/* ORGANISATION FIELD (ONLY IF ORGANISATION USER) */}
      {userType === "organisation" && (

        <TextField
          label="Organisation"
          fullWidth
          margin="normal"
          value={orgName}
          onChange={(e) => setOrgName(e.target.value)}
        />
      )}
  
        <TextField
          label="Name"
          fullWidth
          margin="normal"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
  
        <TextField
          label="Email"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
  
  <Box sx={{ position: "relative", mt: 2 }}>
  <TextField
    label="Password"
    type={showPassword ? "text" : "password"}
    fullWidth
    value={password}
    onChange={(e) => setPassword(e.target.value)}
  />
  <IconButton
    onClick={() => setShowPassword(!showPassword)}
    sx={{
      position: "absolute",
      right: 10,
      top: "50%",
      transform: "translateY(-50%)",
    }}
  >
    {showPassword ? <VisibilityOff /> : <Visibility />}
  </IconButton>
</Box>
  
<Box sx={{ position: "relative", mt: 2 }}>
  <TextField
    label="Confirm Password"
    type={showConfirmPassword ? "text" : "password"}
    fullWidth
    value={confirmPassword}
    onChange={(e) => setConfirmPassword(e.target.value)}
    error={confirmPassword && password !== confirmPassword}
    helperText={
      confirmPassword && password !== confirmPassword
        ? "Passwords do not match"
        : ""
    }
  />

  <IconButton
    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
    sx={{
      position: "absolute",
      right: 10,
      top: "50%",
      transform: "translateY(-50%)",
    }}
  >
    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
  </IconButton>
</Box>
  
        {/* CONSENT SECTION */}
        <div style={{ marginTop: 16, fontSize: 14 }}>
          <label style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
            <input
              type="checkbox"
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
              style={{ marginTop: 3 }}
            />
  
            <span>
              I agree to the{" "}
              <a href="/terms" target="_blank" rel="noreferrer">
                Terms of Service
              </a>{" "}
              and{" "}
              <a href="/privacy" target="_blank" rel="noreferrer">
                Privacy Policy
              </a>
            </span>
          </label>
        </div>

        <div style={{ marginTop: 16, fontSize: 14 }}>
        <span>
            I understand I get a 1-month free trial. After the trial, I may choose to subscribe and enter payment details to continue using the service.
            </span>
        </div>
  
        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{ mt: 3 }}
          disabled={!acceptedTerms}
          onClick={handleRegister}
        >
          Register & Continue
        </Button>
      </form>
  
      <Typography sx={{ mt: 2, textAlign: "center" }}>
        <span
          style={{ color: "#2563eb", cursor: "pointer" }}
          onClick={() => setShowPage("signIn")}
        >
          Back to Sign In
        </span>
      </Typography>
    </>
  );

  const renderForgotPassword = () => (
    <>
      <Typography variant="h6" sx={{ mb: 3, textAlign: "center" }}>
        Reset Password
      </Typography>

      <Box sx={{ mb: 2 }}>

      <ButtonGroup fullWidth>
        <Button
          variant={userType === "organisation" ? "contained" : "outlined"}
          onClick={() => setUserType("organisation")}
        >
          Organisation
        </Button>

        <Button
          variant={userType === "individual" ? "contained" : "outlined"}
          onClick={() => setUserType("individual")}
        >
          Individual
        </Button>
      </ButtonGroup>
      </Box>
    
      <form onSubmit={handleForgotPwd}>
      {userType === "organisation" && (<TextField label="Organisation" fullWidth margin="normal" value={orgName} onChange={e => setOrgName(e.target.value)} /> )}
        
        <TextField label="Email" fullWidth margin="normal" value={email} onChange={e => setEmail(e.target.value)} />
  
        <Button type="submit" variant="contained" fullWidth sx={{ mt: 3 }}>
          Send Reset Link
        </Button>
      </form>
  
      <Typography sx={{ mt: 2, textAlign: "center" }}>
        <span style={{ color: "#2563eb", cursor: "pointer" }} onClick={() => setShowPage("signIn")}>
          Back to Sign In
        </span>
      </Typography>
    </>
  );

const renderPayment = () => (
    <>
      <Typography
          variant="caption"
          sx={{ display: "block", mt: 2, textAlign: "center", color: "text.secondary" }}
        >
          Secured by Stripe
        </Typography>

      <Typography
        variant="h6"
        sx={{ fontWeight: 600, mb: 1.5, textAlign: "center" ,color: "black",fontWeight: "bold"}}
      >
        Verify Payment Method
      </Typography>
      <Divider sx={{ my: 2 }} />
  
      <Typography
      variant="body2"
      sx={{
        color: "#1F2937",
        mb: 3,
        textAlign: "center",
        whiteSpace: "pre-line",
      }}
    >
     {
      orgName == INVERTIBLE_MANAGED_ORG
        ? "Invertible costs €29 per month per organisation. This is a recurring subscription and continues until cancelled. You can cancel anytime in your account settings."
        : "Invertible costs €199 per month per organisation. This is a recurring subscription and continues until cancelled. You can cancel anytime in your account settings."
    }

      {"\n"}
      By continuing, you agree to our Terms of Service.
    </Typography> 
  
      <form onSubmit={handlePayment}>
        {/* Stripe Card Element Container */}
  <Grid container spacing={2} sx={{ mb: 3 }}>
  <Grid item xs={12}>
    <TextField
      fullWidth
      label="Card Holder Name"
      value={billingAddress.billingContactName}
      onChange={(e) =>
        setBillingAddress({
          ...billingAddress,
          billingContactName: e.target.value,
        })
      }
    />
  </Grid>
  <Grid item xs={12}>
    <TextField
      fullWidth
      label="Address Line 1"
      value={billingAddress.line1}
      onChange={(e) =>
        setBillingAddress({
          ...billingAddress,
          line1: e.target.value,
        })
      }
    />
  </Grid>

  <Grid item xs={12}>
    <TextField
      fullWidth
      label="Address Line 2 (Optional)"
      value={billingAddress.line2}
      onChange={(e) =>
        setBillingAddress({
          ...billingAddress,
          line2: e.target.value,
        })
      }
    />
  </Grid>

  <Grid item xs={6}>
    <TextField
      fullWidth
      label="City"
      value={billingAddress.city}
      onChange={(e) =>
        setBillingAddress({
          ...billingAddress,
          city: e.target.value,
        })
      }
    />
  </Grid>

  <Grid item xs={6}>
    <TextField
      fullWidth
      label="Postal Code"
      value={billingAddress.postalCode}
      onChange={(e) =>
        setBillingAddress({
          ...billingAddress,
          postalCode: e.target.value,
        })
      }
    />
  </Grid>

  <Grid item xs={12}>
    <TextField
      fullWidth
      label="Country Code"
      value={billingAddress.country}
      onChange={(e) =>
        setBillingAddress({
          ...billingAddress,
          country: e.target.value.toUpperCase(),
        })
      }
      helperText="Use ISO code, e.g. DE, US, GB"
    />
  </Grid>
</Grid>
        <Box
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: 2,
            p: 2,
            mb: 3,
            backgroundColor: "#fafafa",
          }}
        >
          <CardElement
            options={{
              hidePostalCode: true,
              style: {
                base: {
                  fontSize: "16px",
                  color: "#424770",
                  "::placeholder": { color: "#aab7c4" },
                  fontFamily: "Inter, system-ui, sans-serif",
                },
                invalid: {
                  color: "#9e2146",
                },
              },
            }}
          />
        </Box>
  
        <Button
          type="submit"
          variant="contained"
          fullWidth
          disabled={!stripe || loading}
          sx={{
            py: 1.2,
            backgroundColor: "#2563eb",
            "&:hover": { backgroundColor: "#1e40af" },
          }}
        >
          {loading ? "Verifying…" : "Verify Card"}
        </Button>
        <Typography sx={{ mt: 2, textAlign: "center" }}>
        <span
          style={{ color: "#2563eb", cursor: "pointer" }}
          onClick={() => setShowPage("signIn")}
        >
          Back to Sign In
        </span>
      </Typography>
  
        <Typography
          variant="caption"
          sx={{ display: "block", mt: 2, textAlign: "center", color: "text.secondary" }}
        >
          Secured by Stripe
        </Typography>
      </form>
    </>
  );
  
  

return (
  <Box
  sx={{
    minHeight: "calc(100vh - 92px)", // navbar + footer
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: "#f9fafb",
  }}
>

<Snackbar
      open={!!success}
      autoHideDuration={30000}
      onClose={() => setSuccess("")}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert severity="success" onClose={() => setSuccess("")}>
        {success}
      </Alert>
    </Snackbar>

    <Snackbar
      open={!!error}
      autoHideDuration={30000}
      onClose={() => setError("")}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert severity="error" onClose={() => setError("")}>
        {error}
      </Alert>
    </Snackbar>
      {loading && (
        <div className="overlay">
          <div className="loading-container">
            <Spinner />
            <p className="please-wait">Please wait...</p>
          </div>
        </div>
      )}

<Grid
    container
    direction="row"
    wrap="wrap"
    sx={{
      flex: 1,
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      px: { xs: 1, sm: 2, md: 3 },
      py: 2,
      overflow: "auto",
    }}
  > 
    {/* LEFT CARD */}
    <Grid
      size={{ xs: 12, md: 5 }}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: { xs: 1, md: 2 },
      }}
    >
      <Card
        elevation={3}
        sx={{
          width: "100%",
          maxWidth: 420,
          borderRadius: 3,
          p: 2,
        }}
      >
        <CardContent>
          {showPage === "signIn" && renderSignIn()}
          {showPage === "register" && renderRegister()}
          {showPage === "forgotPwd" && renderForgotPassword()}
          {showPage === "payment" && renderPayment()}
        </CardContent>
      </Card>
    </Grid>

    {/* RIGHT CARD */}
    
    <Grid
  size={{ xs: 12, md: 7 }}
  sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    p: { xs: 1, md: 2 },
  }}
>
  <Box
    sx={{
      width: "100%",
      maxWidth: 820,

      // Main panel can scroll to reveal the complete diagram
      maxHeight: "calc(100vh - 170px)",
      overflowY: "auto",
      overflowX: "hidden",

      backgroundColor: "#fff",
      borderRadius: 4,
      boxShadow: "0 8px 30px rgba(0,0,0,0.08)",

      p: { xs: 2, md: 2 },

      textAlign: "center",

      // Hide main scrollbar
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    }}
  >
    {/* ===================================================== */}
    {/* HEADER */}
    {/* ===================================================== */}

    <Typography
      variant="h6"
      sx={{
        fontWeight: 700,
        mb: 0.5,
      }}
    >
      How Invertible Works?
    </Typography>

    <Typography
      sx={{
        color: "#6b7280",
        mb: 1.5,
        fontSize: "0.92rem",
      }}
    >
      Prebuilt Data Workflows — AI-Assisted Setup, Test & Deploy in Minutes. Built with Rust and SQLite.
    </Typography>

    <Typography
      sx={{
        color: "#6b7280",
        mb: 2,
        fontSize: "0.9rem",
        lineHeight: 1.5,
      }}
    >
      Generate AI-assisted configs, test with real data, use Invertible Functions or custom UDFs, and deploy at the edge.
    </Typography>

    {/* ===================================================== */}
    {/* 30 DAY FREE TRIAL */}
    {/* ===================================================== */}

    <Box
      sx={{
        mb: 2,
        px: 2,
        py: 1.2,

        borderRadius: 2.5,

        backgroundColor: "#ecfdf5",
        border: "1px solid #bbf7d0",
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          color: "#15803d",
          fontSize: "1rem",
        }}
      >
        🎉 30-Day Free Trial
      </Typography>

      <Typography
        sx={{
          color: "#166534",
          fontSize: "0.85rem",
          mt: 0.3,
        }}
      >
        No credit card required. Try all Invertible features free for 30 days.
      </Typography>
    </Box>

    {/* ===================================================== */}
    {/* ORGANIZATION + INDIVIDUAL USER CARDS */}
    {/* ===================================================== */}

    <Box
      sx={{
        display: "flex",
        flexDirection: {
          xs: "column",
          sm: "row",
        },

        gap: 2,

        width: "100%",

        mb: 2,
      }}
    >
      {/* ================================================= */}
      {/* ORGANIZATION USERS */}
      {/* ================================================= */}

      <Box
        sx={{
          position: "relative",

          flex: 1,
          minWidth: 0,

          height: 225,

          border: "1px solid #e5e7eb",
          borderRadius: 3,

          backgroundColor: "#f8fafc",

          overflow: "hidden",

          // TOP FADE
          "&::before": {
            content: '""',

            position: "absolute",

            top: 0,
            left: 0,
            right: 0,

            height: 38,

            zIndex: 2,

            pointerEvents: "none",

            background:
              "linear-gradient(to bottom, #f8fafc 10%, rgba(248,250,252,0))",
          },

          // BOTTOM FADE
          "&::after": {
            content: '""',

            position: "absolute",

            bottom: 0,
            left: 0,
            right: 0,

            height: 25,

            zIndex: 2,

            pointerEvents: "none",

            background:
              "linear-gradient(to top, #f8fafc 10%, rgba(248,250,252,0))",
          },
        }}
      >

<Box
    sx={{
      position: "absolute",
      top: 12,
      bottom: 12,
      right: 5,
      width: 4,
      borderRadius: 10,
      backgroundColor: "#e5e7eb",
      zIndex: 3,
      pointerEvents: "none",
    }}
  >
    <Box
      sx={{
        width: "100%",
        height: "35%",
        borderRadius: 10,
        backgroundColor: "#9ca3af",
      }}
    />
  </Box>

        <Box
          sx={{
            height: "100%",

            overflowY: "auto",

            px: 2,
            pt: 1.5,

            // Important: allows final lines to scroll
            // above the bottom fade.
            pb: 8,

            scrollbarWidth: "none",

            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,

              fontSize: "1rem",

              mb: 1,
            }}
          >
            Organisation Account
          </Typography>

          <Box
            sx={{
              textAlign: "left",

              fontSize: "0.82rem",

              color: "#4b5563",

              lineHeight: 1.7,
            }}
          >
            
            <div>✓ Access all the Invertible features</div>

            <div>✓ Deploy and run solutions for Edge Data Analytics</div>

            <div>✓ Process CSV,JSON,XML and events from MQTT </div>

            <div>✓ Create and manage multiple users</div>

            <div>✓ Test and build configurations</div>

            <div>✓ Create and manage functions</div>

            <div>✓ Access the Functions Marketplace</div>

            <div>✓ Upload data</div>

            <div>✓ Apply functions</div>

            <div>✓ Download results</div>

            <div style={{ height: 45 }} />

          </Box>
        </Box>
      </Box>

      {/* ================================================= */}
      {/* INDIVIDUAL USERS */}
      {/* ================================================= */}

      <Box
        sx={{
          position: "relative",

          flex: 1,
          minWidth: 0,

          height: 225,

          border: "1px solid #e5e7eb",
          borderRadius: 3,

          backgroundColor: "#f8fafc",

          overflow: "hidden",

          // TOP FADE
          "&::before": {
            content: '""',

            position: "absolute",

            top: 0,
            left: 0,
            right: 0,

            height: 38,

            zIndex: 2,

            pointerEvents: "none",

            background:
              "linear-gradient(to bottom, #f8fafc 10%, rgba(248,250,252,0))",
          },

          // BOTTOM FADE
          "&::after": {
            content: '""',

            position: "absolute",

            bottom: 0,
            left: 0,
            right: 0,

            height: 25,

            zIndex: 2,

            pointerEvents: "none",

            background:
              "linear-gradient(to top, #f8fafc 10%, rgba(248,250,252,0))",
          },
        }}
      >

<Box
    sx={{
      position: "absolute",
      top: 12,
      bottom: 12,
      right: 5,
      width: 4,
      borderRadius: 10,
      backgroundColor: "#e5e7eb",
      zIndex: 3,
      pointerEvents: "none",
    }}
  >
    <Box
      sx={{
        width: "100%",
        height: "35%",
        borderRadius: 10,
        backgroundColor: "#9ca3af",
      }}
    />
  </Box>


        <Box
          sx={{
            height: "100%",

            overflowY: "auto",

            px: 2,
            pt: 1.5,

            pb: 8,

            scrollbarWidth: "none",

            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,

              fontSize: "1rem",

              mb: 1,
            }}
          >
            Individual Users
          </Typography>

          <Box
            sx={{
              textAlign: "left",

              fontSize: "0.82rem",

              color: "#4b5563",

              lineHeight: 1.7,
            }}
          >
            <div>✓ Single-user account</div>

            <div>✓ Access the Functions Marketplace</div>

            <div>✓ Discover and use available functions</div>

            <div>✓ Upload data</div>

            <div>✓ Apply functions</div>

            <div>✓ Download results</div>
            <div style={{ height: 45 }} />

          </Box>
        </Box>
      </Box>
    </Box>

    {/* ===================================================== */}
    {/* INVERTIBLE FLOW DIAGRAM */}
    {/* ===================================================== */}

    <Box
      sx={{
        width: "100%",

        maxWidth: 620,

        mx: "auto",

        p: 1,

        borderRadius: 3,

        border: "1px solid #e5e7eb",

        backgroundColor: "#f8fafc",
      }}
    >
      <img
        src="/docs/Invertible_flow.drawio.png"
        alt="Invertible Flow"
        onClick={() => setOpen(true)}
        style={{
          width: "100%",

          height: "auto",

          display: "block",

          borderRadius: 10,

          cursor: "zoom-in",
        }}
      />
    </Box>

    <Typography
      variant="caption"
      sx={{
        mt: 1,

        mb: 1,

        display: "block",

        color: "#9ca3af",
      }}
    >
      Click the diagram to view full screen
    </Typography>

    {/* ===================================================== */}
    {/* FULL SCREEN DIAGRAM */}
    {/* ===================================================== */}

    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="lg"
      fullWidth
    >
      <Box
        sx={{
          position: "relative",
        }}
      >
        <IconButton
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",

            top: 10,
            right: 10,

            color: "#fff",

            background: "rgba(0,0,0,.6)",

            zIndex: 10,

            "&:hover": {
              background: "rgba(0,0,0,.8)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <img
          src="/docs/Invertible_flow.drawio.png"
          alt="Invertible Flow Large"
          style={{
            width: "100%",

            height: "auto",

            display: "block",
          }}
        />
      </Box>
    </Dialog>
  </Box>
</Grid>


  </Grid>
</Box>


  );
};

export default Login;


//card 4242 4242 4242 4242  
//expiry 12 / 34
//backgroundColor: "#f9fafb"
